"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AccordionSize = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _rawAccordion = require("./raw-accordion");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
let AccordionSize = exports.AccordionSize = /*#__PURE__*/function (AccordionSize) {
  AccordionSize["Small"] = "small";
  AccordionSize["Medium"] = "medium";
  return AccordionSize;
}({});
/** An accordion component with internal state */
const Accordion = props => {
  const [expanded, setExpanded] = (0, _react.useState)(Boolean(props.initiallyExpanded));
  (0, _react.useEffect)(() => {
    if (props.initiallyExpanded) {
      setExpanded(Boolean(props.initiallyExpanded));
    }
  }, [props.initiallyExpanded]);
  const onClick = () => {
    setExpanded(!expanded);
    if (props.onClick) {
      props.onClick(!expanded);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_rawAccordion.RawAccordion, (0, _extends2.default)({}, props, {
    expanded: expanded,
    onClick: onClick
  }));
};
var _default = exports.default = Accordion;